import { motion } from 'motion/react';
import styles from './Question.module.css';

function Question({ title, isLong, questionFontSize, delayTransition }) {
  return (
    <motion.div
      className={styles.block}
      initial={{ y: '100vh' }}
      animate={{ y: '-60%' }}
      transition={{ duration: 0.9, delay: delayTransition }}
      key={title}
    >
      <div
        className={styles.question}
        style={{
          fontSize: isLong
            ? `${0.8 * questionFontSize}rem`
            : `${questionFontSize}rem`,
          lineHeight: isLong
            ? `${1.2 * 0.8 * questionFontSize}rem`
            : `${1.2 * questionFontSize}rem`,
        }}
      >
        {title}
      </div>
    </motion.div>
  );
}

export default Question;
